// extracted by mini-css-extract-plugin
export default {"descDiv":"desc_descDiv__IM9yT","heading":"desc_heading__BxOuA","texts":"desc_texts__5nK04","listDiv":"desc_listDiv__Kt9vl","Wrapper":"desc_Wrapper__-LeWB"};